/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_Wc4Inputs */

const en_wc_vs_who_wc4 = /** @type {(inputs: Wc_Vs_Who_Wc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`want to automate documents with scripts or AI agents`)
};

/**
* | output |
* | --- |
* | "want to automate documents with scripts or AI agents" |
*
* @param {Wc_Vs_Who_Wc4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_wc4 = /** @type {((inputs?: Wc_Vs_Who_Wc4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_Wc4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_wc4(inputs)
});
export { wc_vs_who_wc4 as "wc.vs.who_wc4" }